(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      target.classList.replace('oudie-reveal-pending', 'oudie-reveal-visible');
      observer.unobserve(target);
    });
  }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
  const initialize = () => {
    if (motion.matches) return;
    document.querySelectorAll('#MainContent > .shopify-section').forEach(section => {
      if (section.querySelector('.hero')) return;
      const homepage = document.querySelector('#MainContent')?.dataset.template === 'index';
      const targets = section.querySelectorAll(`${homepage ? 'product-card, ' : ''}.oudie-experiences__intro, .oudie-experiences__story, .oudie-appearances__card, .oudie-editorial, .oudie-faq__intro, h2, h3`);
      let index = 0;
      targets.forEach(target => {
        if (target.closest('product-card') && !target.matches('product-card')) return;
        if (target.closest('product-information, variant-catalog, scent-explorer, dialog, .oudie-editorial, .oudie-faq__answers') && !target.matches('.oudie-editorial')) return;
        if (target.parentElement.closest('.oudie-experiences__story, .oudie-experiences__intro, .oudie-appearances__card, .oudie-faq__intro')) return;
        if (target.getBoundingClientRect().top < innerHeight || target.classList.contains('oudie-reveal-pending')) return;
        target.style.setProperty('--oudie-reveal-delay', `${Math.min(index++ % 4, 3) * 65}ms`);
        target.classList.add('oudie-reveal-pending');
        observer.observe(target);
      });
    });
  };
  document.addEventListener('focusin', event => {
    const target = event.target.closest('.oudie-reveal-pending');
    if (target) { target.classList.replace('oudie-reveal-pending', 'oudie-reveal-visible'); observer.unobserve(target); }
  });
  motion.addEventListener('change', () => {
    if (motion.matches) {
      observer.disconnect();
      document.querySelectorAll('.oudie-reveal-pending').forEach(el => el.classList.remove('oudie-reveal-pending'));
    }
  });
  initialize();
})();
